import { MRT_RowSelectionState } from 'material-react-table';
import { useEffect, useState } from 'react';
import { SearchDocument } from 'types/Search';

const useRowSelection = (
  data: SearchDocument[],
  compareModeActive: boolean,
  requestsModeActive: boolean
) => {
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});

  useEffect(() => {
    setRowSelection({});
  }, [compareModeActive, requestsModeActive]);

  return {
    setRowSelection,
    rowSelection
  };
};

export default useRowSelection;
